import React, {useRef, useState, Fragment} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import useOutsideClick from "../../utilities/helperHooks";
import TextInput from "./textInput";

const Select5 = (props) => {

  const {selectItems, selectedItem, selectItemClick, maxItems, useIntl, placeholder, useGraySelect, onAddNew,
    onDeleteOption, useAddButton} = props;
  const [opened, setOpened] = useState(false);
  const [addNewInputIsActive, setAddNewInputIsActive] = useState(false);
  const selectElement = useRef(null);
  const newInputRef = useRef(null);

  useOutsideClick(selectElement, (event) => {
    if (event && event.target && (event.target.classList.contains("select3-dropdown__list-item")
      || event.target.classList.contains("select3-dropdown__list-item-text"))) {
      return
    }
    setOpened(false);
  });

  const onNewInputBlur = (value, selectedItem) => {
    onAddNew(value, selectedItem);
    selectItemClick(selectedItem);
    setAddNewInputIsActive(false);
    setOpened(false);
  }

  const handleSelectItemClick = (selectItem) => {
    if (selectItem.isNewInput) {
      if (!addNewInputIsActive) {
        setAddNewInputIsActive(true);
        setTimeout(() => {
          if (newInputRef && newInputRef.current && newInputRef.current.refs && newInputRef.current.refs.inputElement) {
            newInputRef.current.refs.inputElement.focus();
          }
        }, 0)
      }
      return
    }
    selectItemClick(selectItem);
    setOpened(false);
  };

  const selectItemHeight = 33;
  const styles = {
    height: opened
      ? maxItems && (selectItems.length > maxItems)
        ? (maxItems * selectItemHeight) + "px"
        : (selectItems.length * selectItemHeight) + "px"
      : 0
  }

  const selectedText = !selectedItem
    ? placeholder ? useIntl ? <FormattedMessage id={placeholder}/> : placeholder : "Select"
    : useIntl ? <FormattedMessage id={selectedItem.text}/> : selectedItem.label;

  const toggleOpened = () => setOpened(!opened);

  return (
    <div className={"select3 " + (props.className || "") + (opened ? " select3--active" : "")} ref={selectElement}>
      {useAddButton ? (
        <button className="ui-button5 ui-button5--green ui-button5--add" onClick={toggleOpened}>
          <span className="ui-button-icon ui-button-icon--add"/>
          {placeholder}
        </button>
      ) : (
        <Fragment>
          {useGraySelect ? (
            <div className="select-value" onClick={toggleOpened}>
              <span className="select-value__text">{selectedText}</span>
              <span className="select-value__button"/>
            </div>
          ) : (
            <div className="select5-value" onClick={toggleOpened}>
              <span className="select5-value__selected">
                {selectedText}
              </span>
            </div>
          )}
        </Fragment>
      )}
      <div className="select3-dropdown" style={styles}>
        <ul className={"select3-dropdown__list"
          + (maxItems && (selectItems.length > maxItems) ? " select3-dropdown__list--scroll" : "")}>
          {selectItems.map((selectItem, selectItemIndex) => {
            return (
              <li className={"select3-dropdown__list-item"
                + (selectItem.canBeDeleted ? " flex flex--between flex--center " : "")}
                  key={selectItem.value + selectItemIndex}
                  onClick={() => handleSelectItemClick(selectItem)}>
                {selectItem.isNewInput && addNewInputIsActive ? (
                  <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-left"}
                             style={{width: "calc(100% + 5px)"}}
                             placeholder={selectItem.placeholder || ""}
                             ref={newInputRef}
                             onChange={() => null}
                             onBlur={(value) => onNewInputBlur(value, selectItem)}
                             value={""}/>
                ) : selectItem.html || (
                  <span className={"select3-dropdown__list-item-text"
                    + (selectItem.value === "Custom" ? " select3-dropdown__list-item-text--new" : "")
                    + (selectItem.noHover ? " select3-dropdown__list-item-text--no-hover" : "")}>
                    {useIntl ? <FormattedMessage id={selectItem.label}/> : selectItem.label}
                  </span>
                )}
                {selectItem.canBeDeleted
                  ? <button className="ui-icon-remove2 ui-icon-remove2--small ui-icon-remove2--hover-white" onClick={
                    () => onDeleteOption(selectItem)
                  }/>
                  : null}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

Select5.propTypes = {
  selectItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired, // intlKey
    value: PropTypes.any.isRequired,
  })).isRequired,
  selectItemClick: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  className: PropTypes.string,
  maxItems: PropTypes.number,
  useIntl: PropTypes.bool,
  useGraySelect: PropTypes.bool,
  onAddNew: PropTypes.func,
  onDeleteOption: PropTypes.func,
  useAddButton: PropTypes.bool,
};

export default Select5
